import driver from '@/common/driver/index'
import { openMenu } from '@/utils/menu'
import historyData from '@/common/driver/steps/history_data'
import homeEx from '@/common/driver/steps/home_ex'
import { getCurrentGuide } from '@/api/modules/guide'
import alarmSwitch from '@/common/driver/steps/alarm_switch'
import transportCode from '@/common/driver/steps/transport_code'
import exportData from '@/common/driver/steps/export_data'
import { setGuide } from '@/utils/storage/guide/guide'
import { mineGuide } from '@/api/modules/material'
import { hasPermission } from '@/utils/permission'
import i18n from '@/lang/index'

const map = {
  home_ex: homeEx,
  history_data: historyData,
  alarm_switch: alarmSwitch,
  transport_code: transportCode,
  export_data: exportData
}
let driverObj = null
export const guideStep = async function () {
  let steps = []
  const res = await getCurrentGuide().catch()

  res.result.guideList.forEach(item => {
    if (map[item.code] && map[item.code].length) {
      const filteratedStep = map[item.code].filter(item => {
        // 判断是否有权限执行 无权限会被过滤掉
        if (!item.permission || hasPermission(item.permission)) {
          return true
        }
      })
      filteratedStep.forEach(step => {
        // step.popover.title = item.name
        step.popover.title =  i18n.t('home.' + item.code)
      })
      steps = steps.concat(filteratedStep)
    }
  })
  console.log(steps)

  // 定义跳过button
  const skipButton = createSkipButton()
  const noTipButton = createNoTipButton()

  const mask = createMask()
  driverObj = driver({
    allowClose: false,
    showButtons: [
      'next'
    ],
    nextBtnText: i18n.t('public.next'),
    prevBtnText: i18n.t('public.previous'),
    doneBtnText: i18n.t('guideText.Complete'),
    onNextClick (element, step) {
      if (step.popover.operate) {
        const operate = step.popover.operate

        if (operate.openMenu) {
          openMenu(step.popover.operate.openMenu)
        }
        if (operate.mask !== undefined) {
          mask.style.display = operate.mask ? 'block' : 'none'
        }
      }
      driverObj.moveNext()
    },
    onPopoverRender: (popover, {
      config,
      state
    }) => {
      popover.footerButtons.appendChild(skipButton)
      popover.footerButtons.appendChild(noTipButton)

      // 移除下一条
      // popover.footerButtons.removeChild(popover.footerButtons.children[1])
    },
    onDestroyed () {
      mask.style.display = 'none'
      if (vm.$route.name !== 'Home') {
        vm.$router.push({ name: 'Home' })
      } else {
        location.reload()
      }
      setGuide()
    },
    showProgress: false,
    steps: steps
  })

  driverObj.drive()
}

function createSkipButton () {
  const btn = document.createElement('button')
  btn.innerText = i18n.t('public.skip')
  btn.addEventListener('click', () => {
    driverObj.destroy()
  })
  return btn
}

function createNoTipButton () {
  const btn = document.createElement('button')
  btn.innerText = i18n.t('public.no_tips')
  btn.addEventListener('click', () => {
    mineGuide({ on: 0 }).then(({ result }) => {
      if (result === 200) {
        driverObj.destroy()
        setGuide()

        vm.$message.success(i18n.t('public.tips_close_success'))
      }
    })
  })
  return btn
}

function createMask () {
  const mask = document.createElement('div')
  mask.style.zIndex = '9999'
  mask.style.position = 'fixed'
  mask.style.inset = '0px'
  mask.style.pointerEvents = 'auto'
  document.body.appendChild(mask)
  return mask
}
